// FD-901: the list layout's "keep sub-items expanded" preference. Per browser, not per
// view or project: it is a reading habit, not a property of any one list. localStorage
// can be missing or throw (private mode, blocked site data), and the list must render
// the same either way, so every access is guarded and a failure reads as "off".
const KEY = "fd:list-sub-items-expanded"

export const PREFERENCE_EVENT = "list-sub-items:preference"

export function keepSubItemsExpanded() {
  try {
    return window.localStorage.getItem(KEY) === "1"
  } catch {
    return false
  }
}

export function setKeepSubItemsExpanded(expanded) {
  try {
    window.localStorage.setItem(KEY, expanded ? "1" : "0")
  } catch {
    // Not remembered; this page still applies the choice through PREFERENCE_EVENT.
  }
  window.dispatchEvent(new CustomEvent(PREFERENCE_EVENT, { detail: { expanded } }))
}
